import { Record } from 'immutable';

const EventSearchFilterRecord = Record({
  filterField: null,
  filterValue: null
});

export class EventSearchFilter extends EventSearchFilterRecord {
  filterField: string;
  filterValue: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/event-filter.ts